'use es6';

import identity from 'transmute/identity';
import { createAction } from 'flux-actions';
import { VIEW_PDF_PAGE, VIEW_PDF_ZOOM, VIEW_PDF_RESET } from '../constants/ActionTypes';
const pdfPage = createAction(VIEW_PDF_PAGE, identity);
const pdfZoom = createAction(VIEW_PDF_ZOOM, identity);
const pdfReset = createAction(VIEW_PDF_RESET, identity);
export const changePage = pageIndex => pdfPage(pageIndex);
export const changeZoom = scale => pdfZoom(scale);
export const reset = pdfReset;